import { ProductGroup } from '@/components/blocks/CartRender';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { Avatar, AvatarGroup } from '@mui/material';
import { Fragment } from 'react';

interface ProductsAvatarProps {
	showMaxItems: number;
	items: ProductGroup[];
}

export const ProductsAvatarGroup = ({ showMaxItems, items }: ProductsAvatarProps) => (
	<AvatarGroup
		max={showMaxItems}
		sx={{
			display: 'flex',
			'& .MuiAvatar-root': {
				borderRadius: '8px',
			},
		}}
	>
		{items.length === 0 ? (
			<>
				{Array.from({ length: showMaxItems })
					.slice(0, showMaxItems)
					.map((_, index) => (
						<Avatar key={index} sx={{ bgcolor: 'gray.300' }}>
							{' '}
						</Avatar>
					))}
			</>
		) : (
			<Fragment>
				{items.map((item) => (
					<RenderProductImg
						key={item.partNumber}
						fullImageRaw={item.thumbnail}
						render={(src) => (
							<Avatar
								alt={item.name}
								src={src}
								sx={{
									borderRadius: '8px',
								}}
							/>
						)}
					/>
				))}
			</Fragment>
		)}
	</AvatarGroup>
);
